var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstantWebStatusBarSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 377,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.191,
    y: 0.267,
    width: 375.912,
    height: 12,
    rx: 6,
    fill: "#EAECF6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.267,
    width: 376,
    height: 12,
    rx: 6,
    fill: "#604DBC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.838,
    y: 3.267,
    width: 6.407,
    height: 6,
    rx: 3,
    stroke: "#fff",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 185.971,
    y: 3.267,
    width: 6.407,
    height: 6,
    rx: 3,
    stroke: "#fff",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 366.215,
    y: 3.267,
    width: 6.407,
    height: 6.002,
    rx: 3.001,
    stroke: "#fff",
    strokeWidth: 2
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzc3IiBoZWlnaHQ9IjEzIiB2aWV3Qm94PSIwIDAgMzc3IDEzIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB4PSIwLjE5MTQwNiIgeT0iMC4yNjY5NjgiIHdpZHRoPSIzNzUuOTEyIiBoZWlnaHQ9IjEyIiByeD0iNiIgZmlsbD0iI0VBRUNGNiIvPgo8cmVjdCB5PSIwLjI2Njk2OCIgd2lkdGg9IjM3NiIgaGVpZ2h0PSIxMiIgcng9IjYiIGZpbGw9IiM2MDREQkMiLz4KPHJlY3QgeD0iMi44Mzc4OSIgeT0iMy4yNjY5NyIgd2lkdGg9IjYuNDA2NzgiIGhlaWdodD0iNiIgcng9IjMiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIvPgo8cmVjdCB4PSIxODUuOTcxIiB5PSIzLjI2Njk3IiB3aWR0aD0iNi40MDY3OCIgaGVpZ2h0PSI2IiByeD0iMyIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxyZWN0IHg9IjM2Ni4yMTUiIHk9IjMuMjY2OTciIHdpZHRoPSI2LjQwNjc4IiBoZWlnaHQ9IjYuMDAyMTciIHJ4PSIzLjAwMTA5IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiLz4KPC9zdmc+Cg==";
export { SvgInstantWebStatusBarSuccess as ReactComponent };